import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';

import { getLanguageByLocale } from '@hmax-order/shared/common';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const languageGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const transloco = inject(TranslocoService);
  const lang = route.queryParamMap.get('language');

  if (lang) {
    const language = getLanguageByLocale(lang);
    transloco.setActiveLang(language);
  }

  return true;
};
